import { render, staticRenderFns } from "./chart-render.vue?vue&type=template&id=3a60d0c4&"
import script from "./chart-render.vue?vue&type=script&lang=js&"
export * from "./chart-render.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports